import {createContext} from 'react';

/** @type {WidgetContext} */
const defaultContext = {};
export const FloatButtonContext = createContext(defaultContext);
